import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React from 'react';

/**
 * Starts player step (initialize default step status).
 * Additionally, stops Step rendering until player is ready!
 */
export var withPlayerInitializer = function withPlayerInitializer(WrappedComponent) {
  return function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

      props.player.start();
      return _this;
    }

    _class.prototype.isPlayerReady = function isPlayerReady() {
      var player = this.props.player;

      return player.started;
    };

    _class.prototype.render = function render() {
      return this.isPlayerReady() ? React.createElement(WrappedComponent, this.props) : null;
    };

    return _class;
  }(React.Component);
};